import { Component, Input, OnInit } from '@angular/core';
import {ApiKeysService} from "../../../../services/apikeys.service";
import {Tenant} from "../../../../model/tenant";
import {CommonMessagesService} from "../../../../services/common-messages.service";

@Component({
  selector: 'app-tenant-api',
  templateUrl: './tenant-api.component.html',
  styleUrls: ['./tenant-api.component.scss']
})
export class TenantApiComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public apiKey: string;
  public loadingApiKey: boolean;

  constructor(private apiKeysService: ApiKeysService,
              private commonMessagesService: CommonMessagesService) { }

  ngOnInit(): void {
    this.loadingApiKey = true;
    this.apiKeysService.getTenantApiKey(this.tenant.uuid)
      .toPromise().then( response => this.apiKey = response.apiKey)
      .finally(() => this.loadingApiKey = false);
  }

  confirmAndNewApiKey(): void {
    this.commonMessagesService.showGenerateNewApiKeyConfirmation(() => {
      this.loadingApiKey = true;
      this.apiKeysService.getNewTenantApiKey(this.tenant.uuid)
        .toPromise().then( response => this.apiKey = response.apiKey)
        .finally(() => this.loadingApiKey = false);
    });
  }

  newApiKey(): void {
    this.loadingApiKey = true;
    this.apiKeysService.getNewTenantApiKey(this.tenant.uuid)
      .toPromise().then( response => this.apiKey = response.apiKey)
      .finally(() => this.loadingApiKey = false);
  }

}
